//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {isNullOrEmpty, getFullUrl} from '@nuskin/ns-common-lib';
import pagedown from 'pagedown';
export default {
  name: 'Sustainability',
  props: {
    youTubeVideoId: {
      type: String,
      default: null
    },
    image: {
      type: Object,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    /** List of highlights, each composed with an image url and a markdown description */
    highlights: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    convertMarkdownToHtml(markdown) {
      if (isNullOrEmpty(this.highlights) || isNullOrEmpty(markdown)) {
        return null;
      }

      const markdownLinkRegex = /\[(?<linkText>.*)\]\((?<linkUrl>.*)\)/;
      const markdownText = markdown.replace(markdownLinkRegex, (...args) => {
        const {linkText, linkUrl} = args[args.length - 1];
        return `[${linkText}](${getFullUrl(this.siteUrl, linkUrl)})`;
      });
      const safeConverter = pagedown.getSanitizingConverter();
      const html = safeConverter.makeHtml(markdownText);
      // open links in new tab
      const modifiedHtml = html.replace(/<a /g, `<a target="_blank" `);
      return modifiedHtml;
    }
  }
};
